import classNames from "classnames";
import classes from "~/features/scanDmc/components/PdpScanResultSection/PdpScanResultSection.module.less";
import ScanResultAlert from "~/features/scanDmc/components/ScanResultAlert/ScanResultAlert";
import ContactFormOverlay from "~/features/scanDmc/components/ContactFormOverlay/ContactFormOverlay";
import { appendOverlayParamToUrl, getScanResultFromUrl } from "~/features/scanDmc/utils/scanDmcUtils";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { useEffect, useState } from "react";
import { ScanResultType } from "~/features/scanDmc/types/ScanDMC";
import { LinkButton } from "~/common/components/Link";
import { fetchScanDMCOriginCheck } from "~/features/scanDmc/api/fetchScanDMCOriginCheck";
import { CircularProgress } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";

interface Props {
  className?: string;
  productCode: string;
}

export const PdpScanResultSection = (props: Props) => {
  const [scanResult, setScanResult] = useState(() => getScanResultFromUrl(props.productCode));
  const [redoLoading, setRedoLoading] = useState(false);
  const { t } = useTranslation();

  const overlayParamValue = new URLSearchParams(window.location.href).get("overlayOpen") === "true";
  const { val: overlayOpen, setTrue: openOverlay, setFalse: closeOverlay } = useBooleanState(overlayParamValue);

  if (!scanResult) {
    return null;
  }

  const showRedoScan = scanResult.type === ScanResultType.AlreadyScanned;

  const redoScan = async () => {
    setRedoLoading(true);
    const newScanResult = await fetchScanDMCOriginCheck(scanResult.dmcCode, true);
    setRedoLoading(false);
    setScanResult(newScanResult);
  };

  useEffect(() => {
    appendOverlayParamToUrl(window.location.href, overlayOpen);
  }, [overlayOpen]);

  return (
    <div className={classNames(classes.root, props.className)}>
      <div className={classes.alertRoot}>
        <ScanResultAlert
          openOverlay={openOverlay}
          scanResult={scanResult.type}
          className={redoLoading ? "v-hidden" : undefined}
        />
        {redoLoading && <CircularProgress size={50} className={classes.loading} />}
      </div>

      {showRedoScan && (
        <LinkButton onClick={redoScan} disabled={redoLoading} iconBefore={<Icon type={IconType.Reload} />}>
          {t("feature.scandmc.revalidateBtn")}
        </LinkButton>
      )}

      {overlayOpen && (
        <ContactFormOverlay onClose={closeOverlay} scanResult={scanResult.type} dmcCode={scanResult.dmcCode} />
      )}
    </div>
  );
};
